import { AAResponseMapper, ResponseError, } from "@finarkein/aasdk-core";
export class ResponseMapperFinvu extends AAResponseMapper {
    constructor(response) {
        super(response);
    }
    async getResponse(operation) {
        return new Promise(async (resolve, reject) => {
            try {
                const response = await this.response;
                const { status, message, ...rest } = response;
                const responseObj = {
                    data: rest,
                    aaOperation: response.aaOperation,
                    aaOpAttempt: response.attempt,
                    aaErrorCode: response.errorCode,
                    aaMessage: response === null || response === void 0 ? void 0 : response.message,
                    status: response.status,
                };
                switch (operation) {
                    case "VALIDATE_USER":
                        this.handleValidateUser(response, responseObj);
                        break;
                    case "AA_LOGIN":
                        this.handleAALogin(response, responseObj);
                        break;
                    case "ACCOUNT_DISCOVERY":
                        this.handleAccountDiscovery(response, responseObj);
                        break;
                    case "LINKED_ACCOUNTS":
                    case "CONSENT_DETAILS":
                        this.handleLinkedAccountsOrConsentDetails(response, responseObj);
                        break;
                    case "ALT_MOBILE":
                    case "CONFIRM_ALT_MOBILE":
                        this.handleAltMobile(response, responseObj);
                        break;
                    case "ACCOUNT_LINKING":
                        this.handleAccountLinking(response, responseObj);
                        break;
                    case "CONFIRM_ACCOUNT_LINKING":
                        this.handleConfirmAccountLinking(response, responseObj);
                        break;
                    case "CONSENT_ACTION":
                        this.handleConsentAction(response, responseObj);
                        break;
                    case "USER_INFO":
                    case "LOGOUT":
                        responseObj.status = response.status === "ACCEPT" || response.status === "SUCCESS" ? "SUCCESS" : "FAILURE";
                        break;
                    default:
                        reject(new ResponseError("UNKNOWN_OPERATION", responseObj, "Unknown operation type"));
                }
                if (responseObj.status !== "SUCCESS") {
                    reject(new ResponseError(`${responseObj.status}`, responseObj, response.message || responseObj.message || ""));
                }
                resolve(responseObj);
            }
            catch (e) {
                reject(e);
            }
        });
    }
    handleValidateUser(response, responseObj) {
        if (response.status === "SUCCESS" || response.status === "SEND") {
            responseObj.status = "SUCCESS";
        }
        else if (response.status === "RETRY") {
            responseObj.status = "RETRY";
        }
        else if (response.status === "FAILURE") {
            responseObj.message = response.message;
            switch (response.message) {
                case "Bad Request":
                    responseObj.status = "BAD_REQUEST";
                    break;
                case "Invalid request or request timed out.":
                case "Maximum OTP limit reached for session.":
                case "Error retreiving consent request: Consent request not found":
                case "Consent request not in PENDING status":
                    responseObj.status = "FAILURE";
                    break;
                default:
                    responseObj.status = "UNKNOWN_ERROR";
            }
        }
    }
    handleAALogin(response, responseObj) {
        if (response.status === "SUCCESS" || response.status === "SEND") {
            responseObj.status = "SUCCESS";
        }
        else if (response.status === "FAILURE") {
            responseObj.message = response.message;
            switch (response.message) {
                case "Otp validation failed, try again":
                case "Otp validation failed.":
                case "otp reference and/or otp not set or has invalid values":
                    responseObj.status = "RETRY";
                    break;
                default:
                    responseObj.status = "FAILURE";
            }
        }
    }
    handleAccountDiscovery(response, responseObj) {
        if (response.status === "SUCCESS") {
            responseObj.status = "SUCCESS";
        }
        else if (response.status === "RECORD_NOT_FOUND" || response.status === "RECORD-NOT-FOUND") {
            responseObj.status = "RETRY";
        }
        else if (response.status === "FAILURE") {
            responseObj.message = response.message;
            switch (response.message) {
                case "Bad Request":
                    responseObj.status = "BAD_REQUEST";
                    break;
                case "Something went wrong.":
                    responseObj.status = "FAILURE";
                    break;
                case "Invalid request or request timed out.":
                case "Session Error.":
                    responseObj.status = "SESSION_ERROR";
                    break;
                default:
                    responseObj.status = "FAILURE";
            }
        }
    }
    handleLinkedAccountsOrConsentDetails(response, responseObj) {
        responseObj.status = response.status === "SUCCESS" ? "SUCCESS" : "FAILURE";
    }
    handleAltMobile(response, responseObj) {
        if (response.status === "ACCEPT" || response.status === "SEND") {
            responseObj.status = "SUCCESS";
        }
        else if (response.status === "RETRY" || response.status === "REJECT") {
            responseObj.status = "RETRY";
        }
        else if (response.status === "FAILURE") {
            responseObj.message = response.message;
            responseObj.status = response.message === "Session Error." ? "SESSION_ERROR" : "FAILURE";
        }
    }
    handleAccountLinking(response, responseObj) {
        if (response.status === "SUCCESS") {
            responseObj.status = "SUCCESS";
        }
        else if (response.status === "RETRY" || response.status === "REJECT") {
            responseObj.status = "RETRY";
        }
        else if (response.status === "FAILURE") {
            responseObj.message = response.message;
            switch (response.message) {
                case "Bad Request":
                    responseObj.status = "BAD_REQUEST";
                    break;
                case "Session Error.":
                    responseObj.status = "SESSION_ERROR";
                    break;
                default:
                    responseObj.status = "FAILURE";
            }
        }
        else if (response.status === "RECORD_NOT_FOUND") {
            responseObj.status = "FAILURE";
        }
    }
    handleConfirmAccountLinking(response, responseObj) {
        if (response.status === "SUCCESS") {
            responseObj.status = "SUCCESS";
        }
        else if (response.status === "RETRY" || response.status === "REJECT") {
            responseObj.status = "RETRY";
        }
        else if (response.status === "FAILURE") {
            responseObj.message = response.message;
            switch (response.message) {
                case "Bad Request":
                    responseObj.status = "BAD_REQUEST";
                    break;
                case "Token incorrect.":
                case "Otp validation failed, try again":
                case "Otp validation failed.":
                    responseObj.status = "RETRY";
                    break;
                case "Session Error.":
                    responseObj.status = "SESSION_ERROR";
                    break;
                default:
                    responseObj.status = "RETRY";
            }
        }
        else if (response.status === "RECORD_NOT_FOUND") {
            responseObj.status = "FAILURE";
        }
    }
    handleConsentAction(response, responseObj) {
        if (response.status === "SUCCESS") {
            responseObj.status = "SUCCESS";
        }
        else if (response.status === "RECORD-NOT-FOUND") {
            responseObj.status = "BAD_REQUEST";
        }
        else if (response.status === "FAILURE") {
            responseObj.message = response.message;
            switch (response.message) {
                case "Bad Request":
                case "Invalid linked account(s) selected.":
                    responseObj.status = "BAD_REQUEST";
                    break;
                case "Session Error.":
                    responseObj.status = "SESSION_ERROR";
                    break;
                default:
                    responseObj.status = "UNKNOWN_ERROR";
            }
        }
    }
}
//# sourceMappingURL=ResponseMapperFinvu.js.map